import {$, T} from "../../../../../../../lmb_factory_theme/assets/src/javascript/src/common/drupal/drupal";

class Global {

    /**
     * Initialize event listeners
     */
    init () {
        let body = document.getElementsByTagName('body')[0];
        if (window.scrollY > 0) {
            body.classList.add('js-scrolled');
        }
        function scrollActions() {
            let windowY = (window.scrollY) ? window.scrollY : window.pageYOffset;
            if (windowY > 0) {
                body.classList.add('js-scrolled');
            } else {
                body.classList.remove('js-scrolled');
            }
        }
        // Detect if scrolled
        window.addEventListener('scroll', function () {
            requestAnimationFrame(scrollActions);
        });
    }

    attach(context) {
        this.init(context);
    }
}

export let global = new Global();
